import { pxToRem } from '../../../../utils';
export var menuItemIconStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: v.iconSize,
      height: v.iconSize,
      '& > :first-child': {
        height: '100%',
        width: '100%'
      }
    }, p.hasContent && {
      marginRight: pxToRem(10)
    }, !p.iconOnly && {
      // reduce margins so text has the dominant influence on the vertical height
      marginTop: 0,
      marginBottom: pxToRem(-8),
      verticalAlign: 'top'
    });
  }
};